var module = angular.module('octopusApp.environments');


module.controller('MachineEventsController', function ($scope, machineState, $location, busy, octopusRepository, pollLoop) {
    $scope.machineId = machineState.machineId;
    $scope.isLoading = busy.create();
    $scope.isSaving = busy.create();
    $scope.skip = 0;

    $scope.loadPage = loadPage;

    function loadPage(skip) {
        $scope.skip = skip;
        refresh();
    }

    function refresh() {
        return $scope.isLoading.promise(machineState.load().then(function (machine) {
            $scope.machine = machine;

            return octopusRepository.Events.list({ regarding: $scope.machineId, skip: $scope.skip }).then(function (events) {
                $scope.events = events;
            });
        }));
    }


    pollLoop.create($scope, function () {
        return refresh();
    }).startImmediately();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machines/machine_events_controller.js
// module id = 440
// module chunks = 1